import React from 'react'
import Aos from 'aos'
import FBODImg1 from '../../Images/HR/PurbaSanchalakSamiti/SaabikkaSansthaAadhakshya.png'
import FBODImg2 from '../../Images/HR/PurbaSanchalakSamiti/PrastabitKaryasamiti.png'
import FBODImg3 from '../../Images/HR/PurbaSanchalakSamiti/NirbachitKaryasamiti.png'

const FormerBODs = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const FormerBODList = [
        {
            ID: '1',
            Name: 'साविकका संस्था/अध्यक्ष',
            Image: FBODImg1,
            path: '/FormerBOD/sabikka-adhyakshya'
        },
        {
            ID: '2',
            Name: 'प्रस्तावीत कार्यसमिति',
            Image: FBODImg2,
            path: '/FormerBOD/prastabik-karyasamiti'
        },
        {
            ID: '3',
            Name: 'प्रथम वार्षिक साधारण सभाबाट निर्वाचित कार्यसमिति',
            Image: FBODImg3,
            path: '/FormerBOD/nibartaman-karya-samiti'
        },
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>कनकलक्ष्मी साकोस :: पुर्व संचालक समिति</h2><hr />
                        </div>
                    </div>
                    <div className='branches-body'>
                        <div className='card-container'>
                            {FormerBODList.map((item, id) => {
                                return (
                                    <a href={item.path} onClick={() => window.scrollTo({ top: 0 })}>
                                        <div className='card' key={id} style={{ width: '300px' }} data-aos='fade-right'>
                                            <div className='inner'>
                                                <div className='img-holder'>
                                                    <img src={item.Image} alt='formerbod-Image' />
                                                </div>
                                                <div className='detail'>
                                                    <h3>{item.Name}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default FormerBODs